var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_alert_circled_light",
    "data-name": "UI icon/alert_circled/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51_Stroke_",
    "data-name": "Path 51 (Stroke)",
    d: "M7.8,47.6a7.8,7.8,0,0,0,7.8-7.8V.8A7.8,7.8,0,0,0,0,.8v39A7.8,7.8,0,0,0,7.8,47.6Z",
    transform: "translate(70.201 46)",
    fill: "#ed2024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    d: "M15.6,7.8A7.8,7.8,0,1,1,7.8,0,7.8,7.8,0,0,1,15.6,7.8Z",
    transform: "translate(70.201 101.401)",
    fill: "#ed2024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_134_Stroke_",
    "data-name": "Ellipse 134 (Stroke)",
    d: "M78,156a78,78,0,1,1,78-78A78.088,78.088,0,0,1,78,156ZM78,15.6A62.4,62.4,0,1,0,140.4,78,62.472,62.472,0,0,0,78,15.6Z",
    fill: "#ed2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4aef1a28fd3b1b7471cdcb973ad3cf45.svg";
export { ForwardRef as ReactComponent };